module.exports = __webpack_public_path__ + "img/4.87138815.jpg";